$(document).ready(function() {
    jQuery('.page-content').each(function() {
        var titleList = "";
        $('h2').each(function(index, value) {
           
            if ($(this).closest('.cta-block').length === 0 && $(this).attr('class') != 'page-content__title') 
            {
                $(this).attr('id', 'content-anchor-' + index);
                $(this).css('scroll-margin-top', '5rem');
                titleList += "<li class=\"page-content__item\"><span><a href=\"#" + 'content-anchor-' + index + "\">" + $(this).text() + "</a></span></li>";
            }
        });
        $(this).find('.page-content__lists').empty().append(titleList);
    });
    
    $("[href^='#content-anchor']").click(function(e) {
        e.preventDefault(); 
        var id = $(this).attr("href");
        $('html, body').animate({
            scrollTop: $(id).offset().top - 100
        }, 500);
    });
});

